import UserMenuLink from '@shared/mobileLogoutButton/UserMenuLink';

import { ONLINE_TRANSACTION_LINKS } from './const';
import { OnlineTransactionLinksWrapper } from './styled';

const OnlineTransactionLinks = () => {
  return (
    <OnlineTransactionLinksWrapper>
      {ONLINE_TRANSACTION_LINKS.map(({ id, href, title }) => (
        <UserMenuLink key={id} label={title} href={href} />
      ))}
    </OnlineTransactionLinksWrapper>
  );
};

export default OnlineTransactionLinks;
